import apiClient from '@/core/api/';
import { convertToBlob } from '@/utils/utilities';

//constants
const itemBaseApiURL = 'api/item';
const accountBaseApiURL = 'api/account';
const incidentBaseApiURL = 'api/incident';

export const getDashboardInfo = async (filters = {}) => {
  const params = new URLSearchParams();

  if (filters.dateFrom && filters.dateTo) {
    const fromDate = new Date(filters.dateFrom);
    const toDate = new Date(filters.dateTo);

    if (fromDate > toDate) {
      filters.dateTo = null;
    }
  }

  if (filters.dateFrom) {
    const fromDate = new Date(filters.dateFrom);
    const formattedFrom = fromDate.toISOString().split('T')[0];
    params.append('dateFrom', formattedFrom);
  }
  if (filters.dateTo) {
    const toDate = new Date(filters.dateTo);
    const formattedTo = toDate.toISOString().split('T')[0];
    params.append('dateTo', formattedTo);
  }

  if (filters.status?.id) {
    params.append('statusId', filters.status.id);
  }
  if (filters.email) {
    params.append('email', filters.email);
  }
  if (filters.phone) {
    params.append('phone', filters.phone);
  }
  if (filters.searchScope?.id) {
    params.append('searchScope', filters.searchScope.id);
  }
  if (filters.region?.id) {
    params.append('regionId', filters.region.id);
  }
  if (filters.requesterName) {
    params.append('requesterName', filters.requesterName);
  }
  if (filters.searchText) {
    params.append('searchText', filters.searchText);
  }
  if (filters.subType?.id) {
    params.append('subTypeId', filters.subType.id);
  }

  return await apiClient.get(
    `${itemBaseApiURL}/dashboardinfo?${params.toString()}`
  );
};

export const getInitCreateAccount = async (isEn = false) =>
  await apiClient.get(`${accountBaseApiURL}/initCreateAccount`, {
    params: {
      isEn,
    },
  });

export const getProfileInformation = async () =>
  await apiClient.get(`${accountBaseApiURL}/profile`);

export const createAccount = async (payload) =>
  await apiClient.post(accountBaseApiURL, payload);

export const getInitCatalog = async (isEn = false) =>
  await apiClient.get(`${itemBaseApiURL}/initcatalog`, {
    params: {
      isEn,
    },
  });

export const searchItems = async (payload, page = 1, pageSize = 10) => {
  //validate the page is a number if not set to 1
  if (isNaN(page)) {
    page = 1;
  }
  return await apiClient.post(
    `${itemBaseApiURL}/search?page=${page}&pageSize=${pageSize}`,
    payload
  );
};

export const saveRequest = async (payload) =>
  await apiClient.post(`${itemBaseApiURL}/saverequest`, payload);

export const getRequest = async (businessId) =>
  await apiClient.get(`${itemBaseApiURL}/request/${businessId}`);

export const getDocumentValidation = async (businessId, statusId) =>
  await apiClient.get(
    `${itemBaseApiURL}/request/documentvalidation/${businessId}/${statusId}`
  );

export const downloadItemAttachment = async (id) => {
  const { data } = await apiClient.get(`/api/itemattachment/download/${id}`);
  if (data) {
    convertToBlob(data);
  }
};

export const viewItemAttachment = async (id) => {
  const { data } = await apiClient.get(`/api/itemattachment/download/${id}`);

  const byteChars = atob(data.content);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], {
    type: data.contentType || 'application/pdf',
  });

  const blobUrl = window.URL.createObjectURL(blob);
  return blobUrl;
};

export const saveItemAttachment = (data) => {
  return apiClient.post('/api/ItemAttachment/saveitemattachment', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const sendNotification = (data) => {
  // return apiClient.post(`/api/item/sendnotification/${data[0]}`
  // );
  return apiClient.post('/api/Item/sendnotification', { itemsId: data });
};

export const hideItemReminder = (itemId, hide = true) => {
  return apiClient.get(`/api/item/hide-show/${itemId}/${hide}`);
};
export const getRequestMThan6Month = async () =>
  await apiClient.get(`${itemBaseApiURL}/morethan6`);
export const getRequestHideMThan6Month = async () =>
  await apiClient.get(`${itemBaseApiURL}/hidemorethan6`);
export const removeItemAttachment = (documentId) =>
  apiClient.delete(`/api/itemattachment/remove/${documentId}`);

export const getAttachmentInitCatalog = async () =>
  await apiClient.get(`/api/itemattachment/initcatalog`);

export const getAttachmentsWithStamping = async (businessId) => {
  const { data } = await apiClient.get(`/api/itemattachment/attachments-with-stamping?businessId=${businessId}`);
  return data;
};

export const executeManualStamping = async (itemAttachmentId) => {
  const { data } = await apiClient.post('/api/itemattachment/manual-stamping', {
    itemAttachmentId
  });
  return data;
};

export const submitRequest = async (itemId) =>
  await apiClient.post(`${itemBaseApiURL}/submitrequest/${itemId}`);

export const saveRatingSurvey = async (payload) =>
  await apiClient.post(`${itemBaseApiURL}/saverating`, payload);

export const sendIncidentReport = async (payload) =>
  await apiClient.post(`${incidentBaseApiURL}/sendincidentreport`, payload);

export const updateProfile = async (payload) =>
  await apiClient.put(`${accountBaseApiURL}/updateprofile`, payload);

export const getTrackingEntries = async (requestNumber, isEn = false) =>
  await apiClient.get(`${itemBaseApiURL}/trackingentries/${requestNumber}`, {
    params: {
      isEn,
    },
  });

export const addRequestComment = (businessId, commentText) =>
  apiClient.post(`${itemBaseApiURL}/addcomment`, {
    businessId,
    commentText,
  });

export const getRequestAutoSave = async () =>
  await apiClient.get(`${itemBaseApiURL}/requestautosave`);

export const saveRequestAutoSave = (payload) =>
  apiClient.post(`${itemBaseApiURL}/saverequestautosave`, payload);

export const getRoles = async () => await apiClient.get(`api/role/list`);

export const updateRole = async (userId, newRoleId) =>
  await apiClient.post(`api/account/changeRole/${userId}/${newRoleId}`);
export const getUserRole = async (userId) =>
  await apiClient.get(`api/role/fromuser/${userId}`);
export const updateQuestionAnswer = async (payload) =>
  await apiClient.post(`api/account/UpdateQuestionUser`, payload);

export const resetUserPassword = async (payload) =>
  await apiClient.post(`api/account/resetUserPassword`, payload);

export const submitAuthorizationLetter = async (payload) =>
  await apiClient.post(
    `api/AuthorizationLetter/saveAuthorizationLetter`,
    payload
  );

export const getAuthorizationLetter = async (businessId) =>
  await apiClient.get(`api/AuthorizationLetter/${businessId}`);

export const confirmUser = async (payload) =>
  await apiClient.post(`api/account/confirm/${payload}`);

export const unConfirmUser = async (payload) =>
  await apiClient.post(`api/account/unconfirm/${payload}`);

export const disableUser = async (payload) =>
  await apiClient.post(`api/account/disable/${payload}`);

export const enableUser = async (payload) =>
  await apiClient.post(`api/account/enable/${payload}`);

export const userStatus = async (payload) =>
  await apiClient.get(`api/account/status/${payload}`);
export const removeRequest = async (businessId) =>
  await apiClient.put(`api/item/remove/${businessId}`);

export const deleteUser = async (userId) =>
  await apiClient.put(`api/account/delete/${userId}`);
